import {
    CometChatMessageComposer,
    CometChatMessageHeader,
    CometChatMessageList,
    getLocalizedString,
    CometChatButton,
    CometChatUserEvents
} from "@cometchat/chat-uikit-react";
import "../../styles/CometChatMessages/CometChatMessages.css";
import { useEffect, useState } from "react";
import { CometChat } from "@cometchat/chat-sdk-javascript";
import { logNewUnreadMessage } from "../../../Services/Connection";
import { checkStripeAccount } from "../../../Services/stripeApi";
import Stripe from "../../assets/Stripe.svg"
import { useDispatch } from "react-redux";
import { setPaymentUser,setIsPaymentOpen } from "../../../redux/valueSlice";
import { getUserProfile } from "../../../Services/ShowsApi";
import Tooltip from "@mui/material/Tooltip";
interface MessagesViewProps {
    user?: CometChat.User;
    group?: CometChat.Group;
    headerMenu: () => React.JSX.Element;
    onThreadRepliesClick: (message: CometChat.BaseMessage) => void;
    showComposer?: boolean;
    onBack?: () => void;
}

export const CometChatMessages = (props: MessagesViewProps) => {

    const dispatch = useDispatch()
    const {
        user,
        group,
        headerMenu,
        onThreadRepliesClick,
        showComposer,
        onBack = () => { }
    } = props;

    const [showComposerState, setShowComposerState] = useState<boolean | undefined>(showComposer);
    const [hasStripe, setHasStripe] = useState<boolean | null>(null);
    const [isOpenToCollaborate, setIsOpenToCollaborate] = useState<boolean | null>(null);

    useEffect(() => {
        setShowComposerState(showComposer);
        if (user?.getBlockedByMe?.()) {
            setShowComposerState(false);
        }
    }, [user, showComposer]);

    useEffect(() => {
        const logUnreadMessage = async () => {
            try {
                if ((user as any)?.uid) {
                    console.log("receiverId:", (user as any).uid);
                     const hasStripeAccount = await checkStripeAccount((user as any)?.uid);
                    console.log("Stripe account response:", hasStripeAccount);
                    setHasStripe(hasStripeAccount?.status === 'active' || false);
                    
                    const userProfileRes = await getUserProfile((user as any)?.uid);
                    if ((userProfileRes as any)?.status === 200 && (userProfileRes as any)?.data) {
                        const { body } = (userProfileRes as any)?.data ?? {};
                        if (body?.Data?.[0]) {
                            setIsOpenToCollaborate(body.Data[0].Collaborate === 1);
                        }
                    }
                    
                    await logNewUnreadMessage((user as any).uid);
                }
            } catch (error) {
                console.error("Failed to log unread message:", error);
            }
        };
        logUnreadMessage();
    }, [user]);

    const handleFetchUser = async () => {
        if (hasStripe && isOpenToCollaborate) {
            dispatch(setIsPaymentOpen(true)); // Open popup immediately
            dispatch(setPaymentUser(null));   // Clear previous user data

            // Fetch user profile in background
            const res = await getUserProfile((user as any)?.uid);
            if ((res as any)?.status == 200 && (res as any)?.data) {
                let { body } = (res as any)?.data ?? {}
                if (body) {
                    let Data = body.Data;
                    dispatch(setPaymentUser(Data[0]));
                }
            }
        }
    }

    const getTooltipTitle = () => {
        if (!hasStripe && !isOpenToCollaborate) {
            return "This user hasn't set up payments and is not open to collaboration";
        }
        if (!hasStripe) {
            return "This user hasn't set up payments yet. You can't send money until they do";
        }
        if (!isOpenToCollaborate) {
            return "This user is not open to collaboration";
        }
        return "";
    };

    const auxiliaryButtonView = (
        <Tooltip
            title={getTooltipTitle()}
            arrow
            placement="right"
            disableHoverListener={hasStripe && isOpenToCollaborate}
        >
            <button
                className="cometchat-payment-custom-button"
                style={{
                    opacity: (hasStripe && isOpenToCollaborate) ? 1 : 0.5,
                    cursor: (hasStripe && isOpenToCollaborate) ? "pointer" : "not-allowed",
                    background: "none",
                    border: "none",
                    padding: 0
                }}
                onClick={(hasStripe && isOpenToCollaborate) ? handleFetchUser : undefined}
                disabled={!(hasStripe && isOpenToCollaborate)}
                tabIndex={(hasStripe && isOpenToCollaborate) ? 0 : -1}>
                <div style={{ pointerEvents: (hasStripe && isOpenToCollaborate) ? "auto" : "none" }}>
                    <CometChatButton
                        iconURL={Stripe}
                        onClick={() => {}}
                    />
                </div>
            </button>
        </Tooltip>
    );

    return (
        <div className="cometchat-messages-wrapper">
            <div className="cometchat-header-wrapper">
                <CometChatMessageHeader
                    user={user}
                    group={group}
                    auxiliaryButtonView={headerMenu()}
                    onBack={onBack}
                    hideVideoCallButton={true}
                    hideVoiceCallButton={true}
                />
            </div>
            <div className="cometchat-message-list-wrapper">
                <CometChatMessageList
                    user={user}
                    group={group}
                    onThreadRepliesClick={(message: CometChat.BaseMessage) => onThreadRepliesClick(message)}
                    loadingView={<></>}
                />
            </div>
            {showComposerState ? <div className="cometchat-composer-wrapper">
                <CometChatMessageComposer
                    user={user}
                    group={group}
                    auxiliaryButtonView={auxiliaryButtonView}
                />
            </div> : <div className="message-composer-blocked" onClick={() => {
                if (user) {
                    CometChat.unblockUsers([user?.getUid()]).then(() => {
                        user.setBlockedByMe(false);
                        CometChatUserEvents.ccUserUnblocked.next(user);
                    })
                }
            }}>
                <div className="message-composer-blocked__text">
                    {getLocalizedString("cannot_send_to_blocked_user")} <a>   {getLocalizedString("click_to_unblock")}</a>
                </div>
            </div>}
        </div>
    )
}